import { useHistory } from "react-router";

import React, { useEffect, useState } from 'react'
import ReadWatchComponent from '../common/ReadWatchComponent';
import AppManager from '../../managers/AppManager';
import {
    showLoader,
    removeLoader,
    showToast,
    TOAST_TYPE
} from "deskera-ui-library";
import RouteManager from "../../managers/RouteManager";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { useDispatch, useSelector } from "react-redux";
import ComponentGroupsService from "../../services/ComponentGroupsService";
import { fetchComponentGroups, selectComponentGroup } from "../../Redux/Slices/ComponentGroupsSlice";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import { ComponentGroupsColumnConfig, parseColumnConfig } from "../configs/config";
import Table from "../../services/table";
import AddComponentGroupPopup from "./AddComponentGroupPopup";
import { useTranslation } from "react-i18next";
import { MODULE } from "../user-permissions/PermissionUtils";

function ComponentGroups(props) {
    const { t, i18n } = useTranslation();

    const history = useHistory();
    useEffect(() => {
        RouteManager.setPresenter({ props: props });

    })
    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    const loadComponentGroups = async (config) => {
        try {
            ComponentGroupsService.apiConfig = config;
            const timeout = showDelayedLoader();
            await dispatch(fetchComponentGroups());
            removeDelayedLoader(timeout);
        } catch (err) {}
    };
    var selectedRow = [];

    const [componentGroup, setComponentGroup] = useState(initialState);
    const [refresh, setRefresh] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(10);
    const [showList, setFiltersList] = useState(true);
    const [initialValue, setFilterInitialValue] = useState(0);
    const [showAddPopUp, setShowAddPopUp] = useState(false);
    const [editRowData,setEditRowData] = useState(null);
    const [reload, setReload] = useState(false);

    const dispatch = useDispatch();
    const ComponentGroupsData = useSelector(selectComponentGroup);
    const isActionEnabled = true

    useEffect(() => {
        RouteManager.setPresenter({ props });
        /* API Calls Start */
        loadComponentGroups({});
        /* API Calls End */
        return () => setComponentGroup(initialState);
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(ComponentGroupsData)) {
            const componentGroups = ComponentGroupsData.componentGroups;
            const filterResponse = ComponentGroupsData.filterConfig;
            const rowData = ComponentGroupsColumnConfig(componentGroups);
            let componentGroupColumns = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.COMPONENT_GROUP_LIST))
            const passingData = {
                columnData: deepClone(componentGroupColumns),
                rowData,
                filter: [],
                originalData: componentGroups
            };
            const isFilterListEnabled = ComponentGroupsData.length > 0 ? true : false;
            setComponentGroup(passingData);
            setTotalPageCount(filterResponse.totalPage);
            setCurrentPage(+filterResponse?.page);
            setTotalCount(filterResponse.sizePerPage)
            setFiltersList(isFilterListEnabled);
            setFilterInitialValue(0);
        }
    }, [ComponentGroupsData, reload]);


    const onRowDelete = (data, isForceDelete) => {
        let cId = []
        let params = {}
        if(data.length && data.length != 0) {
            data.forEach(row=>{
                cId.push(row.id)
            })
            params = {
                ids: cId,
                forcedDelete: isForceDelete
            }
        } else {
            cId = data.rowData['id'];
            params = {
                ids: [cId],
                forcedDelete: isForceDelete
            }
        }
        
        try {
            showLoader(t("DEL_COMP_TEMP"));
            Table.deleteComponentGroups(params).finally(removeLoader()).then((response) => {
                showToast(t("DEL_COMP_TEMP_SUCCESS"), TOAST_TYPE.SUCCESS);
                loadComponentGroups({})
            })
        } catch (err) {
            showToast(t("DEL_COMP_TEMP_ERROR"), TOAST_TYPE.FAILURE);
        }

    }
    const onClose = (isSave) => {
        if(isSave) {
            selectedRow = []
        }
        loadComponentGroups({})
        setEditRowData(null)
        setShowAddPopUp(false)
    }
    const addComponentGroup = () => {
        setEditRowData(null)
        setShowAddPopUp(true)
    }
    const onRowEdit = (data) => {
        if(data) {
            if(data.length && data.length != 0) {
                setEditRowData(data[0])
            } else {
                setEditRowData(data.rowData)
            }
            setShowAddPopUp(true)
        }        
    }

    const onContextCancel = () => {
      setReload(!reload)
    }

    return (
        <><ReadWatchComponent
            title={t("NEED_HELP_COMP_TEMP")}
            onRead={AppManager.showComingSoonWarning}
            onWatch={AppManager.showComingSoonWarning}
        />
            <div className="column parent-width flex-1 parent-height">
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DataGridHolderPayroll
                        tableName={TABLES.COMPONENT_GROUP_LIST}
                        displayTableName={t("COMPONENT_TEMPLATE")}
                        allowRowEdit={false}
                        allowColumnEdit={false}
                        allowRowAdd={true}
                        allowColumnAdd={false}
                        allowColumnDelete={true}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        onRowDelete={onRowDelete}
                        onCancelContext={() => {
                            onContextCancel();
                        }}
                        refresh={refresh}
                        addButtonConfig={[{
                            title: String().concat("+ ", t("ADD_COMP_TEMP")),
                            className: "bg-app text-white",
                            onClick: () => addComponentGroup(),
                        }]}
                        allowDataExport={true}
                        gridData={componentGroup}
                        filter={ComponentGroups.filter}
                        onPaginationClick={(requestedPageNumber) => {
                            const config = {
                                ...ComponentGroupsService.apiConfig,
                                CurrentPage: requestedPageNumber, // Books backend pagination offset is 0, so subtract 1
                            };
                            loadComponentGroups(config);
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={isActionEnabled}
                        contextMenu={true}
                        onRowEdit={(data)=>{
                            onRowEdit(data)
                        }}
                        onSelection={(data)=>{
                            selectedRow = data
                        }}
                        isMenuVisible={true}
                        module={MODULE.EARNING_DEDUCTION_TEMPLETE}
                    />
                    {showAddPopUp && (
                        <div className="transparent-background">
                            <AddComponentGroupPopup
                            data={editRowData}
                            
                                onClose={(value) => onClose(value)}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default ComponentGroups
